/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Visibilityprivatedescription2Inputs */

const zh_share_visibilityprivatedescription2 = /** @type {(inputs: Share_Visibilityprivatedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`仅自己可访问`)
};

const en_share_visibilityprivatedescription2 = /** @type {(inputs: Share_Visibilityprivatedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only you can access`)
};

const es_share_visibilityprivatedescription2 = /** @type {(inputs: Share_Visibilityprivatedescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo tú puedes acceder`)
};

/**
* | output |
* | --- |
* | "Only you can access" |
*
* @param {Share_Visibilityprivatedescription2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const share_visibilityprivatedescription2 = /** @type {((inputs?: Share_Visibilityprivatedescription2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Visibilityprivatedescription2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_visibilityprivatedescription2(inputs)
	if (locale === "en") return en_share_visibilityprivatedescription2(inputs)
	return es_share_visibilityprivatedescription2(inputs)
});
export { share_visibilityprivatedescription2 as "share_visibilityPrivateDescription" }